import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const authGuard: CanActivateFn = () => {
    const msalService = inject(MsalService);
    const router = inject(Router);

    const account = msalService.instance.getActiveAccount();
    const userId = (sessionStorage.getItem('UserID') ?? '').trim();

    if (account && userId) {
        return true;
    } else {
        // 👇 si no está logueado, va a /login
        router.navigate(['/login']);
        return false;
    }
};
